export const dataStore = {
  access_token: "access_token",
  refresh_token: "refresh_token",
  login_code: "login_code",
  isLoggedIn: "is_Logged_In",
  currentStep: "current_step",
  subscriptionId: "subscription_id",
};
